import { useState } from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
const VIDEOS = [
  { id: "1udyJhNLcpn9ZR5hFOYiCeqUttt7YzKCQ", name: "Student 1", quote: "Got my admit + scholarship. The SOP team made it feel personal, not templated." },
  { id: "1bUK6Y_GOYCoGLXYCHhW94whTgQT_tBkz", name: "Student 2", quote: "Visa interview prep was legit. Approved in under 5 minutes flat." },
  { id: "1pmhumXGYWKI88jILHXwRsapk1a7gxvRo", name: "Student 3", quote: "Personalised shortlist beat any generic checklist — worth every minute." },
  { id: "1F9_Kh0dO6Y4KgMx1ovzw-lCP7Tm2wbJg", name: "Student 4", quote: "Pre-departure session prepared me for life abroad, not just college." },
  { id: "13ohlJGUYYqzzisomYuKObXDohRN_jETj", name: "Student 5", quote: "From test prep to visa — all under one roof. Saved months of running around." },
  { id: "1d3J4REwBEZ8BVbfIZxxaBIEyjAVg2Y6i", name: "Student 6", quote: "The team genuinely cares. They picked up my calls at 11 PM to explain financials." },
  { id: "1glrhAIHVANcv81POxHGHRoHq50jbfWH-", name: "Student 7", quote: "My SOP finally sounded like me. Got three admits in six weeks." },
  { id: "1cjX7U_c6LZYXLNbjSYEBDMX7mYkpPWLf", name: "Student 8", quote: "Best decision I made. Worth every rupee — and the scholarship paid it back 10x." },
];

const FOLDER_LINK = "https://drive.google.com/drive/folders/12vfeYZxToouOrrzAuUIJWZOJD_sza90f";  // eslint-disable-line no-unused-vars
const thumb = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w1000`;
const embed = (id) => `https://drive.google.com/file/d/${id}/preview`;

function VideoCard({ v }) {
  const [playing, setPlaying] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      className="mx-3 w-[240px] sm:w-[260px] md:w-[280px] bg-white border-2 border-[#282829] rounded-3xl overflow-hidden brutal-shadow-ink flex-shrink-0"
    >
      <div className="relative bg-[#282829]" style={{ aspectRatio: "9 / 16" }}>
        {!playing ? (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            className="group absolute inset-0 w-full h-full"
            aria-label={`Play ${v.name}'s story`}
          >
            <img
              src={thumb(v.id)}
              alt={v.name}
              loading="lazy"
              className="w-full h-full object-cover"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#282829]/80 via-[#282829]/10 to-transparent" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 rounded-full bg-[#c92e34] border-2 border-white grid place-items-center group-hover:scale-110 transition-transform">
                <Play size={30} fill="currentColor" className="text-white ml-1" />
              </div>
            </div>
            <div className="absolute bottom-3 left-3 right-3">
              <div className="inline-block bg-white text-[#282829] text-[10px] font-bold tracking-widest uppercase px-2 py-0.5 rounded-full border-2 border-[#282829]">
                Watch Now
              </div>
            </div>
          </button>
        ) : (
          <iframe
            src={`${embed(v.id)}?autoplay=1`}
            title={v.name}
            allow="autoplay; encrypted-media"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          />
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="inline-block w-3 h-3 rounded-full bg-[#c92e34] border-2 border-[#282829]" />
          <div className="font-display text-lg leading-tight">{v.name}</div>
        </div>
        <p className="text-xs text-[#282829]/70 leading-relaxed line-clamp-3">"{v.quote}"</p>
      </div>
    </motion.div>
  );
}

export default function SuccessStudents() {
  return (
    <section className="grid-bg py-20 md:py-28 bg-white overflow-hidden" data-testid="success-students-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 mb-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <span className="inline-block bg-[#282829] text-white text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border-2 border-[#282829] -rotate-2">
              Real Students · Real Wins
            </span>
            <h2 className="font-display text-5xl md:text-7xl mt-4 leading-[0.9]">
              Side effects of our <span className="text-[#c92e34]">student</span><br />brandings.
            </h2>
          </div>
        </div>
      </div>

      <Marquee gradient={false} gradientWidth={60} speed={55} pauseOnHover>
        {[...VIDEOS, ...VIDEOS].map((v, i) => (
          <VideoCard key={`${v.id}-${i}`} v={v} />
        ))}
      </Marquee>
    </section>
  );
}
